export default __webpack_public_path__ + "static/media/order-railed.91b48558.png";